module.exports = __webpack_public_path__ + "static/media/bible.10bce739.jpg";